<div style="max-height: 100vh; overflow: auto;">
  <h1 class="black">Bitte wählen Sie Ihre Firma:</h1>
  <mat-spinner *ngIf="loading; else tenantSelect"></mat-spinner>

  <ng-template #tenantSelect>
    <div *ngFor="let tenant of tenants">
      <a [href]="getTenantLink(tenant.domains[0])">
        <button mat-stroked-button style="width: 100%; margin-bottom: 1em; color: black">{{tenant.name}}</button>
      </a>
      <br/>
    </div>
  </ng-template>
</div>
